// logConsoleIfAllowed can be used to safely log to console for debugging purposes. It will check the hostname and only
// log to console if app is running on localhost or DEV env
export const logConsoleIfAllowed = (...data) => {
  if (['dev.gigasheet.com', 'localhost', 'dev.supergiga.co'].includes(window.location.hostname)) {
    console.log(...data); // eslint-disable-line no-console
  }
};
